import React, { useEffect, useRef, useState } from 'react';
import {Button, Modal, List, Dropdown, notification} from 'tea-component';
import { SourceSteep1 } from '@/pages/datalab/pages/Multidimensional/Analysis/components/HeaderData/addSourceSteep1';
import SourceSteep2 from '@/pages/datalab/pages/Multidimensional/Analysis/components/HeaderData/addSourceSteep2';
import type { IGetTableInfoDto } from '@dbl/services/dataSource';
import { ITableJoinRelation } from '@/pages/datalab/pages/Multidimensional/Analysis/components/HeaderData/interface';
import SvgIcon from "@home/components/SvgIcon";
import {namespace} from "@/pages/datalab/pages/Multidimensional/Analysis/model";
import { getChartDetail } from '@dbl/services/chart';
import {getLocalText} from "@/pages/datalab/utils/utils";
import { DATALAB_ANALYSIS_ERROR_CODE } from '@dbl/core/global';
// import { useTokenFailureSetSessionCache } from '../..';

export enum Step {
  One,
  Two,
  There,
}

const AutoReportType = {
  Template: 'auto_create', // 用模板自动创建报表
  Table: 'create_table' // 创建空白报表, 图表类型默认是表格
};

export interface AddSourceProps {
  close: () => void;
  formatMessage: Function;
  gameCode: string;
  joinTables: IGetTableInfoDto[];
  joinRelations: ITableJoinRelation[];
  getSuccess: Function;
  autoSelectTable: boolean;
  isEn: boolean;
  showSelfJoin: boolean;
  isOpenSelfJoin: boolean;
  commonFormatMessage: Function;
  chartType?: string;
  locale: string;
  dispatch: Function;
  isHaveChart: boolean;
  isHaveTables: boolean;
  errorFormatmessage: Function;
  openDetailModal: Function;
}

export default function AddSource(props: AddSourceProps) {
  const { formatMessage, errorFormatmessage, close, gameCode, joinTables, joinRelations, getSuccess, showSelfJoin, isOpenSelfJoin, commonFormatMessage, locale, dispatch, isHaveChart = false, isHaveTables, openDetailModal, isEn} = props;

  const joinSettingRef = useRef(); // JoinSetting实例

  const [selectTables, setSelectTables] = useState<any[]>([]);

  // selfJoin 是弹窗内部 的自关联状态数据管理; isOpenSelfJoin是多维分析页面model内的自关联状态管理, 只有在提交按钮时可以改变.
  const [selfJoin, setSelfJoin] = useState(isOpenSelfJoin);
  
  // 记录模板id, 用于判断是否自动创建报表
  const [templateId, setTemplateId] = useState<number|undefined>(joinTables.length === 1 ? joinTables[0].template_list?.[0]?.task_id : undefined);
  // 第二步中表信息和字段加载的状态
  const [statusOfStep2, setStatusOfStep2] = useState('');

  const [curStep, setCurStep] = useState<Step>(Step.One); // 目前所处阶段
  // const steps = [
  //   { id: `${Step.One}`, label: formatMessage('step_one_title') },
  //   { id: `${Step.Two}`, label: formatMessage('step_two_title') },
  // ];
  // const { takeEffect, userFailureValue } = useTokenFailureSetSessionCache(
  //   useMemo(
  //     () => ({ selectTables, curStep }),
  //     [curStep, selectTables],
  //   ),
  // );
  // useEffect(() => {
  //   setCurStep(autoSelectTable ? Step.Two : Step.One);
  // }, []);
  useEffect(() => {
    setSelectTables(joinTables.map((item) => ({ table_id: item.table_id, table_name: item.table_name, database_uuid: item.database_uuid, driver: item.driver, db_name: item.db_name,customize_name: item.customize_name,customize_name_en: item.customize_name_en})));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(joinTables)]);
  
  const handleSubmit = async () => {
    const {
      error,
      joinTables,
      joinRelations,
    }: { error: Boolean; joinTables: IGetTableInfoDto[]; joinRelations: ITableJoinRelation[]; } =
      joinSettingRef.current?.getTableInfosAndTableJoinRelations();
    if (error) {
      return;
    }
    
    if (isHaveTables) {
      // 已存在数据源的情况下, 修改数据源, 进行提示
      const result = await Modal.confirm({
        message: formatMessage('confirm_replace_title'),
        description: (<div dangerouslySetInnerHTML={{ __html: formatMessage('confirm_replace_info')}} />),
        okText: commonFormatMessage('confirm'),
        cancelText: commonFormatMessage('cancel'),
        className: 'dbl-datasource-confirm',
        maskStyle: {zIndex: 1001},
      });
      
      if (!result) return;
    }
    
    // if (selectTables.length === 1 && selectTables[0].table_id === joinTables)
    getSuccess({ joinTables, joinRelations, isOpenSelfJoin: selfJoin });
    notification.success({
      // eslint-disable-next-line no-nested-ternary
      description: selfJoin ? formatMessage("self_join_success") : (joinTables.length === 1) ? formatMessage("add_table") : formatMessage("join_table", { count: joinTables.length })
    });
    close();
  };

  // useEffect(() => {
  //   if (takeEffect) {
  //     const { selectTables, curStep } = userFailureValue || {};
  //     setCurStep(curStep);
  //     setSelectTables(selectTables);
  //   }
  // }, [takeEffect, userFailureValue]);

  return (
    <>
      {/* <Stepper*/}
      {/*  className="add-Source-stepper dbl-add-source-stepper"*/}
      {/*  type="default"*/}
      {/*  steps={steps}*/}
      {/*  current={`${curStep}`}*/}
      {/*  style={{ marginTop: '0' }}*/}
      {/*/ >*/}
      <Modal.Body >
        <div style={{ display: curStep === Step.One ? '' : 'none' }}>
          <SourceSteep1
            gameCode={gameCode}
            selectTables={selectTables}
            setSelectTables={setSelectTables}
            selfJoin={selfJoin}
            setSelfJoin={setSelfJoin}
            commonFormatMessage={commonFormatMessage}
            isEn={locale === 'en-US'}
            formatMessage={formatMessage}
            openDetailModal={openDetailModal}
          />
        </div>
        <div style={{ display: curStep === Step.Two ? '' : 'none' }}>
          <SourceSteep2
            gameCode={gameCode}
            commonFormatMessage={commonFormatMessage}
            isEn={locale === "en-US"}
            formatMessage={formatMessage}
            ref={joinSettingRef}
            oldJoinTables={joinTables}
            oldJoinRelations={joinRelations}
            curStep={curStep}
            setCurStep={setCurStep}
            selectTables={selectTables}
            setSelectTables={setSelectTables}
            selfJoin={selfJoin}
            setSelfJoin={setSelfJoin}
            showSelfJoin={showSelfJoin}
            setTemplateId={setTemplateId}
            setStatusOfStep2={setStatusOfStep2}
          />
        </div>
        {/* {*/}
        {/*  isHaveChart && <div style={{ display: curStep === Step.There ? '' : 'none' }}>*/}
        {/*    <SourceSteep3 dispatch={dispatch} commonFormatMessage={commonFormatMessage} chartType={chartType} />*/}
        {/*  </div>*/}
        {/* }*/}
      </Modal.Body>
      <Modal.Footer className="add-Source-footer">
        {
          (curStep === Step.Two) && (<>
            <Button
              disabled={statusOfStep2 === "loading"}
              type="weak"
              onClick={() => {
                const {error, joinTables, joinRelations,} = joinSettingRef.current?.getTableInfosAndTableJoinRelations();
                if (error) {
                  return;
                }
                
                const tableNames = selectTables?.map(item => getLocalText(isEn, item?.customize_name, item?.customize_name_en, item?.table_name)) || [];
                openDetailModal({
                  resetProps: {
                    isSingle: selectTables.length === 1,
                    title: (<div dangerouslySetInnerHTML={{__html: tableNames.join('<span style="color: #838697;margin-left: 4px; margin-right: 4px">&</span>')}} />)
                  },
                  tableInfos: joinRelations,
                  tableIds: joinTables.map(item => item.table_id),
                  dataTables: joinTables,
                });
              }}
            >
              {formatMessage('preview_data')}
            </Button>
            <Button
              disabled={statusOfStep2 === "loading"}
              type="weak"
              onClick={() => {
                let stepsVal;
                if (isHaveChart) {
                  stepsVal = curStep === Step.Two ? Step.One : Step.Two;
                } else {
                  stepsVal = Step.One;
                }
                setCurStep(stepsVal);
              }}
            >
              {formatMessage('prev_step')}
            </Button>
          </>
          )
        }
        {
          (curStep === Step.One) && <Button
            type="primary"
            onClick={() => {
              setCurStep(Step.Two);
            }}
            disabled={selectTables.length === 0}
          >
            {formatMessage('next_step')}
          </Button>
        }
        {
          (curStep === Step.Two) && <Button
            type="primary"
            /* eslint-disable-next-line @typescript-eslint/no-misused-promises */
            onClick={handleSubmit}
            disabled={selectTables.length === 0}
          >
            {formatMessage('submit')}
          </Button>
        }
        {
          // eslint-disable-next-line eqeqeq
          (isHaveChart && (selectTables.length === 1) && curStep == Step.Two && (statusOfStep2 === 'normal') && (!selfJoin) && templateId) && (
            <AutoCreateReportButton
              formatMessage={formatMessage}
              autoCreate={async () => {
                const isSame = selectTables[0].table_id === joinTables[0]?.table_id;
                if (isSame) {
                  close();
                  return;
                }
                handleSubmit();
                
                const taskRsp = await getChartDetail({
                  task_id: templateId,
                  game_code: gameCode,
                });
                await dispatch({
                  type: `${namespace}/getTaskDetail`,
                  payload: {
                    response: taskRsp,
                    task_id: undefined,
                  },
                });
                
                await dispatch({
                  type: `${namespace}/getDataAnlysis`,
                  payload: {
                    isEn: locale === "en-US"
                  },
                  callback: (payload: {errorMsg: string;}) => {
                    if (payload?.errorMsg && payload?.errorCode !== 40005) {
                      notification.error({
                        className: 'dbl-analysis-msg',
                        description: DATALAB_ANALYSIS_ERROR_CODE?.includes(payload?.errorCode) ? errorFormatmessage({id: `dbl_error_${payload?.errorCode || '1'}`}, {name: payload?.errorData, msg: payload?.errorMsg}) : payload?.errorMsg,
                        duration: 3000
                      });
                    }
                    
                    dispatch({
                      type: `${namespace}/save`,
                      payload: {
                        ...(payload || {}),
                        calculateHashForSave: true,
                        analysisRunning: false,
                        analysisReqId: '',
                        dragState: {
                          currentDrag: '',
                          errorDrag: {},
                        },
                      }
                    });
                  },
                });

              }}
              createTable={() => {
                handleSubmit();
                dispatch({
                  type: `${namespace}/save`,
                  payload: {
                    chartType: 'Table',
                    columnFilters: [],
                    columnCompares: [],
                    columnMetrics: [],
                    columnDimensions: [],
                    previousHashForSave: '',
                    previousHashForAnalysis: '',
                    resetState: true,
                  },
                });
              }}
            />
          )
        }
      </Modal.Footer>
    </>
  );
}

export function AutoCreateReportButton(props: { formatMessage: Function; autoCreate: Function; createTable: Function; }) {
  const { formatMessage, autoCreate, createTable } = props;
  const [reportType, setReportType] = useState(AutoReportType.Template);
  return (<>
    <Button
      type="primary"
      onClick={() => {
        switch (reportType) {
          case AutoReportType.Template: {
            // 用模板创建报表
            autoCreate();
            return;
          }
          case AutoReportType.Table:
          default: {
            // 创建空白报表, 图表默认为表格
            createTable();
          }
        }
      }}
    >
      {formatMessage(reportType)}
    </Button>
    <Dropdown
      button={<SvgIcon type={'arrow-down'}/>}
      appearance="button"
      placement={'bottom-end'}
      className={'add-Source-footer-auto-type'}
    >
      <List type="option">
        {
          Object.values(AutoReportType).map(value => (
            <List.Item
              key={value}
              selected={reportType === value}
              onClick={() => {
                setReportType(value);
              }}
            >
              {formatMessage(value)}
            </List.Item>
          ))
        }
      </List>
      
    </Dropdown>

  </>);
}
